type CategoryProps = {
  id: string
  name: string
}

export const Categories = [
  {
    "id": "1",
    "name": "Comum"
  },
  {
    "id": "2",
    "name": "Token Dinâmico"
  },
  {
    "id": "3",
    "name": "Lista"
  },
  {
    "id": "4",
    "name": "Geração de Certificado"
  },
] as CategoryProps[]